module.exports = __webpack_public_path__ + "static/media/bindEnglish.6ac8cfc5.gif";